import React from 'react'
import PropTypes from 'prop-types'

// Shared section heading (Tailwind) — one primitive for consistent tab section titles (NFR-23).
function SectionHeadline({ children, className }) {
  return (
    <h2 className={`text-base font-bold text-gray-dark ${className}`.trim()}>
      {children}
    </h2>
  )
}

SectionHeadline.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

SectionHeadline.defaultProps = {
  className: '',
}

export default SectionHeadline
